// frontend/src/utils/nativeBridge.ts
/**
 * Native Bridge Abstraction Layer for Capacitor Integration
 * Handles Web vs Native (iOS / Android) capabilities smoothly
 */

export const isNativePlatform = (): boolean => {
    return typeof window !== 'undefined' && !!(window as any).Capacitor?.isNativePlatform();
};

export const getPlatform = (): 'ios' | 'android' | 'web' => {
    if (typeof window === 'undefined') return 'web';
    const cap = (window as any).Capacitor;
    if (cap?.isNativePlatform()) {
        return cap.getPlatform() as 'ios' | 'android';
    }
    return 'web';
};

/**
 * Share PDF or Report URL using Native Share Sheet or Web Share API
 */
export const shareReport = async (title: string, text: string, url: string): Promise<boolean> => {
    try {
        if (navigator.share) {
            await navigator.share({ title, text, url });
            return true;
        } else if (isNativePlatform() && (window as any).Capacitor?.Plugins?.Share) {
            await (window as any).Capacitor.Plugins.Share.share({ title, text, url });
            return true;
        } else {
            // Fallback: Copy link to clipboard
            await navigator.clipboard.writeText(url);
            alert('Link copied to clipboard!');
            return true;
        }
    } catch (e) {
        console.warn('Share operation cancelled or failed:', e);
        return false;
    }
};

/**
 * Trigger haptic vibration feedback for mobile buttons
 */
export const hapticFeedback = (style: 'light' | 'medium' | 'heavy' = 'light') => {
    if (typeof window === 'undefined') return;
    if ('vibrate' in navigator) {
        const ms = style === 'light' ? 10 : style === 'medium' ? 25 : 50;
        try { navigator.vibrate(ms); } catch (e) {}
    }
};
